import { InsightsSpendingSkeleton } from '@/components/ui'
import {
  BulkEditTransactionsDialog,
  DeleteTransactionsDialog,
  EditTransactionDialog,
  useFetchTransactions,
  useInsights,
  useLoadingTransactions,
  useTransactions,
} from '@/modules/projects'
import { MerchantsInsights } from '../components'

interface MerchantsPageProps {
  slug: string
}

export function MerchantsPage({ slug }: MerchantsPageProps) {
  useFetchTransactions(slug)

  const transactions = useTransactions()
  const isLoading = useLoadingTransactions()
  const insights = useInsights()

  if (isLoading) return <InsightsSpendingSkeleton />

  return (
    <>
      <BulkEditTransactionsDialog />
      <DeleteTransactionsDialog />
      <EditTransactionDialog />
      <MerchantsInsights
        merchants={insights?.merchantStats ?? []}
        transactions={transactions}
      />
    </>
  )
}
